export default __webpack_public_path__ + "static/media/undraw_finance_re_gnv2.1deb4d5b.svg";